// extracted by mini-css-extract-plugin
export default {"unauthorized":"ProtectedRoute_unauthorized__p2q+h"};